// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1J__7","info":"Note_info__1ufyH","note":"Note_note__31eP8","actions":"Note_actions__2tYel"};